import axios from 'axios'
import { paymentUrl, paymentTypeUrl, paymentMethodUrl, getHeader } from '@/config'

const state = {
  typeList: [],
  methodList: [],
  paymentByNo: {
    id: null,
    group_no: null,
    prepayment_date: null,
    payment_date: null,
    finish_date: null,
    category: null,
    subtotal: '0',
    round: '0',
    discount: '0',
    discount_percentage: '0',
    total: '0',
    method_id: null,
    method: null,
    type_id: null,
    type: null,
    bank_id: null,
    bank: null,
    account_code: null,
    account: null,
    notes: null,
    vendor_no: null,
    vendor: null,
    customer_no: null,
    customer: null,
    branch_no: null,
    branch: null,
    company_no: null,
    company: null,
    status: null,
    lock: false,
    giro_no: null,
    bank_name: null,
    report_no: null,
    ref_no: null,
    refs: [{
      group_no: null,
      total: 0
    }],
    sales: [{
      id: null,
      payment_no: null,
      purchasing_no: null,
      payment_date: null,
      price: '0',
      method_id: null,
      method: null,
      type_id: null,
      type: null,
      bank_id: null,
      bank: null,
      notes: null,
      prepayment_date: null,
      group_no: null,
      account_code: null,
      account: null
    }],
    purchasings: [{
      id: null,
      payment_no: null,
      purchasing_no: null,
      payment_date: null,
      price: '0',
      method_id: null,
      method: null,
      type_id: null,
      type: null,
      bank_id: null,
      bank: null,
      notes: null,
      prepayment_date: null,
      group_no: null,
      account_code: null,
      account: null
    }]
  },
  payment: {
    id: null,
    group_no: null,
    prepayment_date: null,
    payment_date: null,
    finish_date: null,
    category: null,
    subtotal: '0',
    round: '0',
    discount: '0',
    discount_percentage: '0',
    total: '0',
    method_id: null,
    method: null,
    type_id: null,
    type: null,
    bank_id: null,
    bank: null,
    account_code: null,
    account: null,
    notes: null,
    vendor_no: null,
    vendor: null,
    customer_no: null,
    customer: null,
    branch_no: null,
    branch: null,
    company_no: null,
    company: null,
    status: null,
    lock: false,
    giro_no: null,
    bank_name: null,
    report_no: null,
    ref_no: null,
    refs: [{
      group_no: null,
      total: '0'
    }],
    sales: [{
      id: null,
      payment_no: null,
      purchasing_no: null,
      payment_date: null,
      price: '0',
      method_id: null,
      method: null,
      type_id: null,
      type: null,
      bank_id: null,
      bank: null,
      notes: null,
      prepayment_date: null,
      group_no: null,
      account_code: null,
      account: null
    }],
    purchasings: [{
      id: null,
      payment_no: null,
      purchasing_no: null,
      payment_date: null,
      price: '0',
      method_id: null,
      method: null,
      type_id: null,
      type: null,
      bank_id: null,
      bank: null,
      notes: null,
      prepayment_date: null,
      group_no: null,
      account_code: null,
      account: null
    }]
  }
}

const mutations = {
  SET_PAYMENT_TYPE (state, obj) {
    state.typeList = obj
  },
  SET_PAYMENT_METHOD (state, obj) {
    state.methodList = obj
  },
  SET_PAYMENT (state, obj) {
    state.payment = obj
  },
  SET_PAYMENT_BY_NO (state, obj) {
    state.paymentByNo = obj
  }
}

const actions = {
  getPaymentTypeList: ({ commit }) => {
    axios.get(paymentTypeUrl, { headers: getHeader() })
      .then(response => {
        console.log('type List')
        commit('SET_PAYMENT_TYPE', response.data.data)
      })
  },
  getPaymentByNo: ({ commit }, payload) => {
    axios.post(paymentUrl + '/by-no', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_PAYMENT_BY_NO', response.data.data)
      })
  },
  getPaymentMethodList: ({ commit }) => {
    axios.get(paymentMethodUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_PAYMENT_METHOD', response.data.data)
      })
  },
  getPaymentShow: ({ commit }, payload) => {
    axios.get(paymentUrl + '/' + payload.id, { headers: getHeader() })
      .then(response => {
        commit('SET_PAYMENT', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
